module.exports = __webpack_public_path__ + "img/H3.aeaf76eb.png";